/**
 * @param event {Event}
 * @param link {string}
 */
window.elementSelectValue = (event, link) => {
  event = event || window.event;

  if (!link) {
    return;
  }
  /**
   * @type HTMLSelectElement
   */
  const target = event.target;
  if (!target) {
    return;
  }

  /**
   * @type HTMLElement
   */
  const element = document.querySelector(`[data-link="${link}"]`);
  if (element) {
    element.innerText = target.value;
  }
}
